import { createClient } from 'contentful';
import logger from 'logger';

const client = createClient({
  space: '1nn68m27ytft',
  accessToken:
    process.env.NODE_ENV === 'prod'
      ? process.env.REACT_APP_CONTENTFUL_API
      : process.env.REACT_APP_CONTENTFUL_PREVIEW_API,
  host:
    process.env.NODE_ENV === 'prod'
      ? 'cdn.contentful.com'
      : 'preview.contentful.com'
});

console.log('NODE_ENV', process.env.NODE_ENV);

export async function get(id) {
  try {
    const entry = await client.getEntry(id);
    return entry;
  } catch (err) {
    logger.warn(err, {
      context: 'Error getting Trumpism by id',
      metaData: { trumpismId: id }
    });
    throw err;
  }
}

export async function search(date) {
  try {
    const entry = await client.getEntries({
      content_type: 'trumpItem',
      'fields.date[match]': date
    });
    return entry;
  } catch (err) {
    logger.error(err, {
      context: 'Error searching Trumpism by date.',
      metaData: { date }
    });
    throw err;
  }
}

export async function getActions() {
  try {
    const actions = await client.getEntries({
      content_type: 'actionItem',
      include: 1,
      order: 'fields.order'
    });
    return actions;
  } catch (err) {
    logger.error(err, { context: 'Error getting actions' });
    throw err;
  }
}



// WEBPACK FOOTER //
// ./src/services/contentfulApi.js